import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer-two">
      <div className="logo-shape"></div>
      <div className="container">
        <div className="footer-main-one">
          <div className="row">
           <div className="col-xl-3 col-md-6">
              <div className="footer-two-subscribe">
                <div className="footer-two-logo">
                  <Link to="#"><img alt="logo" src="/assets/images/logo.png" width="300" /></Link>
                </div>
                <p>A Unit of Wall Street Merchants Private Limited.
We strictly comply with RBI guidelines and have instituted a robust Grievance Redressal Cell to address all types of complaints.</p>
              </div>
            </div>
            <div className="col-xl-3 col-lg-3 col-md-5">
              <div className="footer-two-link">
                <h3>Services</h3>
                <ul>
                  <li><i className="flaticon-right-arrow"></i><a href="/">Home</a></li>
                   <li><i className="flaticon-right-arrow"></i><a href="/about">About Us</a></li>
                  <li><i className="flaticon-right-arrow"></i><a href="/contact">Contact Us</a></li>
                  <li><i className="flaticon-right-arrow"></i><a href="/service">Services</a></li>
                  <li><i className="flaticon-right-arrow"></i><a href="/faq">FAQ</a></li>
                  <li><i className="flaticon-right-arrow"></i><a href="/Term-and-condition">Terms & Condition</a></li>
                </ul>
              </div>
            </div>
            <div className="col-xl-2 col-lg-4 col-md-6">
              <div className="footer-two-link m-0 adjust-down">
                <ul>
                  <li><i className="flaticon-right-arrow"></i><a href="/privacy-policy">Privacy Policy</a></li>
                  <li><i className="flaticon-right-arrow"></i><a href="/refundpolicy">Refund Policy</a></li>
                  <li><i className="flaticon-right-arrow"></i><a href="/KycPolicy">KYC Policy</a></li>
                  <li><i className="flaticon-right-arrow"></i><a href="/GrievancePolicy">Grievance Redressal Policy</a></li>
                  <li><i className="flaticon-right-arrow"></i><a href="/InterestRatePolicy">Interest Rate Policy</a></li>
                    {/*  <li><i className="flaticon-right-arrow"></i><a href="/disclaimer">Disclaimer</a></li> */}
                </ul>
              </div>
            </div>
             <div className="col-xl-4 col-lg-5 col-md-7">
              <div className="footer-two-contact">
                <div className="footer-two-contact-inner ">
                   <a className="menu-phone" href="tel:+919911998997">
                <i className="flaticon-phone"></i><h5> +91 9911998997</h5>
              </a>
                </div>
                <div className="footer-two-contact-inner">
                  
                 <Link className="menu-phone">
                <i className="flaticon-location"></i><h5>A 304, I Thum Tower, Sector 62, Noida7</h5>
              </Link>
                </div>
                <div className="footer-two-contact-inner">
                    <a className="menu-phone" href="mailto:info@wallstreetfinz.com">
                <i className="flaticon-mail"></i><h5>  info@wallstreetfinz.com</h5>
              </a>
                </div>
              </div>
            </div>
            
          </div>
        </div>
      </div>
      <div className="container-fluid p-0">
        <div className="footer-lower-two">
          <div className="container">
            <div className="row row-gap-3">
              <div className="">
                <div className="footer-copy-right-one text-end">
                  <p>Copyright © {new Date().getFullYear()} Wall Street Merchants Private Limited All Rights Reserved.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;